import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = {
  button: {
    margin: '5px 5px'
  }
};

const enhance = compose();

const button = enhance(
  ({ classes, id = null, onClickAction = null, disabled }) => {
    return (
      <Button
        disabled={disabled}
        className={classes.button}
        variant="contained"
        color="primary"
        onClick={() => (id ? onClickAction(id) : onClickAction())}
      >
        チケット分割
      </Button>
    );
  }
);

export default withRouter(withStyles(styles)(button));
